<template>
  <AppView
    padd-bottom
  >

    <template v-slot:top-app-view>
      <transition name="fade" mode="out-in" appear>
        <CompanyHeader :company="company" :loading="loadingCompany" />
      </transition>
    </template>

    <transition name="fade" mode="out-in" appear>

      <div v-if="errorCompany" class="tw-mt-12" key="errmsg">
        <p class="tw-py-12 tw-text-base tw-text-center" v-html="errorCompany"></p>
      </div>

      <div v-else-if="loadingCompany" class="tw-mt-12" key="lodng">
        <p class="tw-py-12 tw-text-base tw-text-center">Loading...</p>
      </div>

      <div v-else key="bdy">
        <transition name="fade" mode="out-in" appear>

          <div class="app-view-grid px-body">
            <div class="app-view-grid__col-74">
              <portal to="modal-body" key="mdl">
                <EditTaskBadge
                  :company="company"
                  :program="activeCompanyProgram"
                  @created-success="closeModal(); getCompanyTasksBadges();"
                />
              </portal>

              <template>
                <div class="tw-flex tw-items-center tw-pt-10 tw-pb-4">
                  <img
                    data-src="/img/edit-goals.png"
                    src="/img/edit-goals.png"
                    style="width: 80px; height: 80px;"
                    class="tw-object-cover tw-block tw-mr-8"
                    async
                  >
                  <h3 class="font-title tw-text-xl tw-tracking-wider">
                    Tasks Badges
                  </h3>

                  <BaseButton
                    text="Create Task Badge"
                    class="tw-ml-auto"
                    @click="promptCreateTaskBadge"
                  />
                </div>
                <div class="tw-border-t tw-border-app-black-11 tw-mb-16"></div>
                <div></div>
              </template>

              <!-- TASKS BADGES -->
              <ViewMore
                class="tw-flex tw-flex-wrap stacked-grid stacked-grid--stack-three lg:stacked-grid--stack-three"
                :list="tasksBadges"
                :limit="6"
                v-slot="{ item: taskBadge }"
              >
                <div class="tw-border tw-rounded-10 tw-p-4 tw-bg-gray-200 tw-flex tw-flex-col tw-items-center-- tw-relative">
                  <UserPhoto
                    :photo="taskBadge.url"
                    class="tw-mb-2 tw-inline-block"
                    photo-size="tw-h-20 tw-w-20 tw-rounded-10"
                  />
                  <p class="tw-mb-2">{{taskBadge.name}}</p>
                  <div v-if="taskBadge.goal?.id" class="tw-mb-2">
                    <p class="tw-text-sm tw-bg-gray-300 tw-rounded-10 tw-p-2 tw-inline-block tw-leading-none">
                      <span class="opacity-54">Goal</span>
                      <br />
                      {{taskBadge.goal?.goal || '---'}}
                    </p>
                  </div>
                  <p class="tw-text-sm tw-bg-gray-300 tw-rounded-10 tw-p-2 tw-inline-block tw-leading-none" v-html="taskBadge.description">
                  </p>
                  <div class="tw-absolute tw-top-0 tw-right-0 tw-p-2">
                    <BaseButton
                      text="Delete"
                      class="tw-border-0 tw-bg-red-100 tw-text-red-500 tw-p-1 tw-rounded-3"
                      confirm
                      confirm-message="Are you sure you want to delete this task badge?"
                      @click="deleteTaskBadge(taskBadge)"
                    >
                    </BaseButton>
                  </div>
                </div>
              </ViewMore>

            </div>
          </div>

        </transition>
      </div>

    </transition>
  </AppView>
</template>

<script>
import _sortBy from 'lodash/sortBy';
import _reverse from 'lodash/reverse';

import CompanyHeader from '@/views/Companies/Company/_partials/CompanyHeader.vue';
import EditTaskBadge from '@/views/Companies/Company/_partials/EditTaskBadge.vue';

import UserPhoto from '@/components/UserPhoto.vue';

import companyMixin from '@/mixins/company';
import companyProgramMixin from '@/mixins/companyProgram';

export default {
  name: 'EditCompanyTasksBadgesView',
  components: {
    CompanyHeader,
    UserPhoto,
    EditTaskBadge,
  },
  mixins: [companyMixin, companyProgramMixin],
  props: ['id', 'programId'],
  data() {
    return {
      tasksBadges: [],
    };
  },
  methods: {
    async getCompanyTasksBadges() {
      const programId = this.programId || this.activeCompanyProgram.id;
      const tasksBadges = await this.$store.dispatch('getCompanyProgramTasksBadges', [this.company.id, programId]);

      if (Array.isArray(tasksBadges)) {
        this.tasksBadges = _reverse(_sortBy(tasksBadges, 'dateOfPost'));
      }
    },
    async deleteTaskBadge(taskBadge) {
      await this.$store.dispatch('deleteCompanyProgramTaskBadge', taskBadge.id);
      await this.getCompanyTasksBadges();
    },
    async promptCreateTaskBadge() {
      await this.$nextTick();

      // open modal
      this.$store.commit('openModal', [true, 'modal']);
    },
  },
  async created() {
    // get company
    await Promise.all([
      this.getCompany(),
    ]);

    await this.$nextTick();

    // assert user company permissions
    if (!this.hasPermission) {
      this.$router.push({
        name: 'app',
      });

      return false;
    }

    await this.getCompanyProgram();
    await this.$nextTick();

    if (!this.hasProgramPermission) {
      this.$router.push({
        name: 'app',
      });

      return false;
    }

    await this.getCompanyTasksBadges();

    await this.$nextTick();
    await this.$nextTick();

    return true;
  },
};
</script>

<style>

</style>
